import * as React from 'react';
import { Button, createStyles, Group, Text, useMantineTheme, ActionIcon } from "@mantine/core";
import { read, utils } from "xlsx";
import Page from '../../components/layout/Page';
import axios from "axios";
import produce from 'immer';
import { showMessage } from "../../lib/notification";
import useStore from "../../store";
import { API_URL } from "../../config";
import { Dropzone, MS_EXCEL_MIME_TYPE } from "@mantine/dropzone";
import { IconTableImport, IconUpload, IconX, IconSquareRoundedMinus } from "@tabler/icons-react";

interface ExcelColumn {
    label: string;
    value: string;
}

interface IUploadResponse {
    status?: string;
    result?: string;
    message?: string;
    statusCode?: string;
}

const columns: ExcelColumn[] = [
    { value: "ORDER_NUMBER", label: "№" },
    { value: "featuredOrder", label: "Онцолсон" },
    { value: "groupNumber", label: "a100_id" },
    { value: "vivaNumber", label: "viva_id" },
    { value: "title", label: "Дууны нэр" },
    { value: "titleEn", label: "Дууны нэр /Англи/" },
    { value: "singer", label: "Дуучин" },
    { value: "singerEn", label: "Дуучин /Англи/" },
    { value: "code1", label: "A100" },
    { value: "code2", label: "HD-VIVA" },
    { value: "categoryNumber", label: "Жанр" },
    { value: "lyricBy", label: "Үг" },
    { value: "musicBy", label: "Ая" },
    { value: "youtubeLink", label: "YouTube" },
    { value: "phonograms", label: "Фонограм" },
    { value: "clipValue", label: "Клип эсэх" },
    { value: "contract", label: "Гэрээ" },
    { value: "access", label: "Хандалт" },
    { value: "licenseLyric", label: "Зөвшөөрөл үг" },
    { value: "licenseSound", label: "Зөвшөөрөл ая" },
    { value: "licenseVideo", label: "Зөвшөөрөл бичлэг" },
    { value: "licenseSinger", label: "Зөвшөөрөл дуучин" },
    { value: "likeCount", label: "Like" },
    { value: "voc", label: "VOC" },
    { value: "statusValue", label: "Төлөв" },
    { value: "createdDate", label: "Үүссэн" }


    // { value: 'groupNumber', label: 'Бүлэг' },
    // { value: 'vivaNumber', label: 'Жанр' },
    // { value: 'categoryNumber', label: 'Жанр' },
    // { value: 'title', label: 'Нэр /Монгол/' },
    // { value: 'vocal', label: 'Вокал' },
    // { value: 'code1', label: 'Код-1' },
    // { value: 'code2', label: 'Код-2' },
    // { value: 'singer', label: 'Дуучин' },
    // { value: 'titleEn', label: 'Нэр /Англи/' },
    // { value: 'singerEn', label: 'Дуучин /Англи/' },
    // { value: 'link', label: 'Холбоос' },
    // { value: 'lyricBy', label: 'Яруу найрагч' },
    // { value: 'musicBy', label: 'Дууны хөгжим' },
];

const ImportExcel = () => {

    const { classes } = useStyles();
    const token = useStore(state => state.auth.token);

    const theme = useMantineTheme();
    const openRef = React.useRef<() => void>(null);

    const [ data, setData ] = React.useState<Record<string, any>[] | null>(null);
    const [ error, setError ] = React.useState<string | null>(null);

    const handleExcelImport = async (payload: File) => {
        const f = await payload.arrayBuffer();
        const wb = read(f); // parse the array buffer
        const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
        const excelData: any[] = utils.sheet_to_json(ws, {
            header: columns.map((column) => column.value),
        });
        setData(
            produce(excelData, draft => {
                draft.shift();
            })
        );
        setError(null);
    };

    const handleSubmit = async () => {
        try {
            const params = {
                songs: data,
            }
            const axiosInstance = axios.create();
            const response = await axiosInstance.post<IUploadResponse>(`${API_URL}/api/song/import`, params, {
                headers: {
                    'Authorization': token
                }
            });
            if (response.data?.result === 'OK') {
                showMessage('Амжилттай', 'green')
            } else {
                console.log('err')
                showMessage('Алдаа гарлаа')
                if (response.data.message) {
                    // @ts-ignore
                    setError(response?.data.message);
                }
            }
            setData(null);
        } catch (e) {
            // @ts-ignore
            setError(e?.response?.data?.message)
        }
    }

    const removeRow = (index: number) => {
        setData(
            produce((draft) => {
                if (draft) {
                    draft.splice(index, 1);
                }
            })
        );
    }

    return (
        <Page>
            <Page.Header title={'Дуунууд'}>
                <Button onClick={() => openRef?.current?.()}>Файл сонгох</Button>
                {
                    data && (
                        <Button
                            ml={'sm'}
                            color={'color-secondary'}
                            onClick={handleSubmit}
                        >
                            Хадгалах
                        </Button>
                    )
                }
            </Page.Header>
            <Page.Body>
                {
                    error && (
                        <div className={classes.error}>
                            {error}
                        </div>
                    )
                }
                {
                    data ?
                        (
                            <div className={classes.tableWrapper}>
                                <table className={classes.table}>
                                    <thead>
                                    <tr>
                                        {
                                            columns.map((column, index) => {
                                                return (
                                                    <th key={column.value} className={classes.headerCell}>
                                                        {column.label}
                                                    </th>
                                                )
                                            })
                                        }
                                        <th className={classes.headerCell}/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data.map((row, index) => {
                                            return (
                                                <tr key={index}>
                                                    {
                                                        columns.map((column,  index) => {
                                                            return (
                                                                <td key={`${column.value}-${index}`} className={classes.cell}>
                                                                    {row[column.value] ?? null}
                                                                </td>
                                                            )
                                                        })
                                                    }
                                                    <td className={classes.cell}>
                                                        <ActionIcon color='red' size='md' radius='md' onClick={() => removeRow(index)}>
                                                            <IconSquareRoundedMinus />
                                                        </ActionIcon>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        )
                        :   (
                            <Dropzone
                                multiple={false}
                                openRef={openRef}
                                onDrop={(files) => handleExcelImport(files[0])}
                                onReject={(files) => console.log('rejected files', files)}
                                maxSize={3 * 1024 ** 2}
                                accept={MS_EXCEL_MIME_TYPE}
                            >
                                <Group position="center" spacing="xl" style={{ minHeight: 220, pointerEvents: 'none' }}>
                                    <Dropzone.Accept>
                                        <IconUpload
                                            size={50}
                                            stroke={1.5}
                                            color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
                                        />
                                    </Dropzone.Accept>
                                    <Dropzone.Reject>
                                        <IconX
                                            size={50}
                                            stroke={1.5}
                                            color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
                                        />
                                    </Dropzone.Reject>
                                    <Dropzone.Idle>
                                        <IconTableImport size={50} stroke={1.5} />
                                    </Dropzone.Idle>

                                    <div>
                                        <Text size="xl" inline>
                                            Энд дарах эсвэл эксель файл энд чирснээр дуу импортлох боломжтой
                                        </Text>
                                    </div>
                                </Group>
                            </Dropzone>
                        )
                }
            </Page.Body>
        </Page>
    )
};

const useStyles = createStyles(() => {
    return {
        tableWrapper: {
            overflow: 'auto'
        },
        table: {
            borderCollapse: 'collapse',
        },
        headerCell: {
            border: '1px solid black',
            backgroundColor: '#f3f3f3',
            fontWeight: 600
        },
        cell: {
            border: '1px solid black',
            padding: '2px 5px'
        },
        error: {
            background: '#f36f84',
            color: '#fff',
            borderRadius: 6,
            padding: '1rem',
            textAlign: 'center',
            fontSize: 15,
            marginBottom: '1rem'
        },
    }
})

export default ImportExcel;